import { IGetBannerResetRequest } from '../models/requestModels'
import { IBanner } from '../models/responseModels'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class GetBannerResetApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/banner/banner-reset',
      requesterInfo,
    })
  }

  public async getBannerReset(Id: number): Promise<any> {
    this.props.url = `${this.props.url}/${Id}`
    return await this.getAsync<IBanner[]>()
  }
}
